<template>
  <div v-loading="arhLoading"   style="width: 100%; min-height: 700px">
   
    <el-row>
      <el-col :span="24">
        <h3 class="arhTillte">{{$t(`arh.graph`)}}</h3>
        <div style="padding-left: 9%;font-size:12px;color:rgba(0,0,0,0.6);margin-top: 10px;">{{ $t(`home.figure`) }}</div>

        <div
          id="arhBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
    <!-- 24小时数据 -->
    
   <el-row>
      <el-col :span="24">
        <h3 class="arhTillte"> {{$t(`arh.dayGraph`)}}</h3>
        <div style="padding-left: 9%;font-size:12px;color:rgba(0,0,0,0.6);margin-top: 10px;">{{ $t(`home.figure2`) }}</div>

        <div
          id="arhDayBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
  
 </div>
</template>

<script>
import IndexJs from "../arh999/index"
export default {
  mixins:[IndexJs]
}
</script>

<style>
  .arhTillte{
   margin-left: 45%;
   color: rgba(0,0,0,0.6);
   
  }
</style>